<template>
  <div class="container p-4">
    <div class="row">
      <div class="col">
        <div class="card small p-4">
          <div class="card-title pl-4 pb-0">
            <h6>
              Números detalhados por status de acompanhamento - por cidade
            </h6>
          </div>
          <div v-if="!this.citiesStatuses.length" class="card-body">
            Não existem dados para exibir
          </div>
          <div v-else>
            <div class="card-body">
              <bar-chart :options="options" :chart-data="datacollection" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BarChart from "./BarChart.js";
import { reportsComputed, reportsMethods } from "../../state/helpers";

export default {
  components: {
    BarChart
  },
  data() {
    return {
      datacollection: {},
      options: {
        responsive: true,
        maintainAspectRation: true,
        scales: {
          scaleOverride: true,
          scaleSteps: 2,
          xAxes: [
            {
              stacked: true,
              gridLines: {
                display: false
              }
            }
          ],
          yAxes: [
            {
              stacked: true,
              ticks: {
                beginAtZero: true,
                precision: 0
              },
              type: "linear"
            }
          ]
        }
      }
    };
  },
  mounted() {
    this.getCitiesStatuses();
    this.fillData();
  },
  methods: {
    ...reportsMethods,
    configLabel(type) {
      const statuses = [
        {
          status: "no_restriction",
          label: "S/ restrições",
          backgroundColor: "#28a745"
        },
        {
          status: "social_isolation",
          label: "Em isolamento social",
          backgroundColor: "#ffc107"
        },
        {
          status: "suspected_of_contamination",
          label: "Suspeita de contaminação",
          backgroundColor: "#fd7e14"
        },
        {
          status: "hospitalized",
          label: "Hospitalizado",
          backgroundColor: "#dc3545"
        },
        { status: "death", label: "Óbito", backgroundColor: "#343a40" }
      ];
      return statuses.find(item => item.status === type);
    },
    generateLabels() {
      const labels = this.citiesStatuses.map(item => item.city);
      return [...new Set(labels)];
    },
    getValues(type) {
      const filteredTypes = this.citiesStatuses.filter(
        item => item.status === type
      );

      return this.generateLabels()
        .map((place, index) => {
          const filteredTypesIndex = filteredTypes.findIndex(
            v => v.city === place
          );
          if (filteredTypesIndex >= 0) {
            return filteredTypes[filteredTypesIndex].amount;
          } else return 0;
        })
        .map(value => value);
    },
    generateDatasets() {
      const types = this.citiesStatuses.map(item => item.status);
      const uniqTypes = [...new Set(types)];

      return uniqTypes.map(type => ({
        label: this.configLabel(type).label,
        backgroundColor: this.configLabel(type).backgroundColor,
        data: this.getValues(type)
      }));
    },
    fillData() {
      this.datacollection = {
        labels: this.generateLabels().map(label => label),
        datasets: this.generateDatasets()
      };
    }
  },
  computed: {
    ...reportsComputed
  }
};
</script>

<style>
.small {
  max-width: 600px;
  margin: 30px auto;
}
</style>
